import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router";
import cs from "classnames";

import * as modes from "~/modules/modal/modes";
import { toggleLoadPhone } from "~/modules/loads/actions";
import Toggler from "~/components/common/Toggler";
import mapDispatch from "~/misc/mapDispatch";
import { dataQa, Header, Attr, Desc } from "./helpers";
import { modalChange } from "~/modules/modal/actions";
import { alterHideConfirm } from "~/modules/hideConfirm/actions";
import { emptyCompany } from "~/modules/myCompany/actions";
// import PremiumMark from '~/components/common/PremiumMark';
import Button from "~/components/common/Button";
import BidButton from "~/components/BidButton";
import config from "~/config";
import { track } from "~/misc/metrics";
import { getType, Type as loadsTypes } from "~/misc/loadTypes";
import store from "~/store";
import BookButton from "~/components/BookButton";
import { makeBidDynamic, accpetBid } from "~/modules/bids/actions"
import {createBookDynamic } from "~/modules/bookings/action"
import { status as loadStatus, getLoadStatus, bidStatus, bookStatus } from "~/misc/loadStatus";
import UnlockBtn from '~/components/common/UnlockEst';
import css from "./index.css";
import btnCss from "./button.css"
import { getLocation, getSearchId } from "~/misc/actionLocation";
import get from "lodash/get";
const randomShowPop = () => {
  const data = store.getState();
  const user = data.user;
  const emailSwitchData = data.dots.mainSwitch.data.email_switch;
  const emailPopSwitch = emailSwitchData.switch;
  const emailPopRate = emailSwitchData.chance;

  // service close switch close verify pop
  if (!emailPopSwitch) {
    return false;
  }

  // profile msg incomplete
  if (
    user.emailVerified &&
    user.firstName &&
    user.lastName &&
    user.phone &&
    user.verify_result
  ) {
    return false;
  }

  // random open verify pop rate
  const randow1 = Math.round(Math.random() * 100);
  return randow1 < emailPopRate;
};

const PhoneToggler = connect(
  (state, props) => ({
    toggled: state.loads.phoneToggled[props.data.id],
  }),
  mapDispatch({
    toggle: (props) => {
      if (randomShowPop()) {
        return modalChange("pop", {
          source: "show-phone-button",
          type: "pop_download_and_send_verify_email",
        });
      }
      return toggleLoadPhone(props.data.loadIdentity);
    },
  })
)(Toggler);

const phoneCode = /\d\d\d/;

const PhonePreview = ({ phone }) => {
  const matched = phone && `${phone}`.match(phoneCode);

  if (!matched) {
    return <span>Show Phone</span>;
  }

  return (
    <div className={css.showPhoneText}>
      Show Phone <br />
      {`(${matched[0]}) XXX-XXXX`}
    </div>
  );
};

const LoadActions = ({ 
  bid, book, status , accpetBid, showRC,updateBook ,updateBid
}) => {
  const { myloadsType ,isBid ,isBooking, bidPrice, bidType, bidNextNode, bookType, rcFiles, bidMsg } = status;
  if(updateBook || updateBid) {
    console.log("Update");
  }
  if (myloadsType === "booking") {
    switch (bookType) {
      case bookStatus.BOOK_SUCCESS:
      case bookStatus.BOOK_SUCCESS_DEF:
        return (
          <div  className={btnCss.doubleButton}>
            <Button 
              mods= {["wide", "large"]}
              className = {cs(btnCss.normalize, btnCss.colourGreen)}
            >
              Booking Successful
            </Button>
            {
              rcFiles.length ? <Button 
                onClick= {()=>showRC(rcFiles)}
              >
                View RC
              </Button> : null
            }
            
          </div>
          
        )
      case bookStatus.BOOK_CONFIRM:
      case bookStatus.BOOK_CONFIRM_WAITING:
        return (
          <div className={btnCss.doubleButton}>
            <Button 
              mods= {["wide", "large"]}
              className = {cs(btnCss.normalize, btnCss.colourGreen)}
            >
              Booking Confirmed
            </Button>
            {
              rcFiles.length ? <Button 
                onClick= {()=>showRC(rcFiles)}
              >
                View RC
              </Button> : null
            }
          </div>
          
        )
      case bookStatus.BOOK_LOAD_DROP:
      case bookStatus.BOOK_LOAD_DROP_DEF: 
      case bookStatus.BOOK_LOAD_DROP_REJ:
        return (
          <Button 
            mods= {["wide", "large"]}
            className = {cs(btnCss.normalize, btnCss.colourGrey)}
          >
            Load Dropped by Broker
          </Button>
        )
      case bookStatus.BOOK_SUCCESS_DEF:
        return (
          <Button 
            mods= {["wide", "large"]}
            className = {cs(btnCss.normalize, btnCss.colourGreen)}
          >
            Booking Confirmed
          </Button>
        )
      case bookStatus.BOOK_REJECT: 
        return (
          <Button 
            mods= {["wide", "large"]}
            className = {cs(btnCss.normalize, btnCss.colourRed)}
          >
            Booking Rejected
          </Button>
        )
      case bookStatus.BOOK_EXPIRED: 
        return (
          <Button 
            mods= {["wide", "large"]}
            className = {cs(btnCss.normalize, btnCss.colourGrey)}
          >
            Booking has expired
          </Button>
        )
      case bookStatus.BOOK_SHIPPER_CANCEL: 
        return (
          <Button 
            mods= {["wide", "large"]}
            className = {cs(btnCss.normalize, btnCss.colourGrey)}
          >
            Load Cancelled by Shipper
          </Button>
        )
      case bookStatus.BOOK_CANCEL: 
        return (
          <Button 
            mods= {["wide", "large"]}
            className = {cs(btnCss.normalize, btnCss.colourGrey)}
          >
            Booking has been cancelled
          </Button>
        )
      case bookStatus.BOOK_DELIVERED: 
        return (
          <Button 
            mods= {["wide", "large"]}
            className = {cs(btnCss.normalize, btnCss.colourGreen)}
          >
            Shipment Delivered
          </Button>
        )
      default:
        console.log('bookType :>> ', bookType);
        return (
          <div></div>
        )
    }
  }else if(myloadsType === "bid"){
    switch (bidType) {
      case bidStatus.BID_LOAD_DROP:
        return (
          <Button 
            mods= {["wide", "large"]}
            className = {cs(btnCss.normalize, btnCss.colourGrey)}
          >
            Load Dropped by Broker
          </Button>
        )
      case bidStatus.BID_LOAD_DELETED:
        return (
          <Button 
            mods= {["wide", "large"]}
            className = {cs(btnCss.normalize, btnCss.colourGrey)}
          >
            Load Deleted by Broker
          </Button>
        )
      case bidStatus.BID_EXPIRED:
        return (
          <Button 
            mods= {["wide", "large"]}
            className = {cs(btnCss.normalize, btnCss.colourGrey)}
          >
            Expired
          </Button>
        )
      case bidStatus.BID_UNAVALIABLE:
        return (
          <Button 
            mods= {["wide", "large"]}
            className = {cs(btnCss.normalize, btnCss.colourGrey)}
          >
            Load no longer available
          </Button>
        )
      case bidStatus.BID_LOST:
        return (
          <Button 
            mods= {["wide", "large"]}
            className = {cs(btnCss.normalize, btnCss.colourGrey)}
          >
            Offer Lost
          </Button>
        )
      case bidStatus.BID_REJECT:
      case bidStatus.BID_LOAD_REJECT:
        return (
          <Button 
            mods= {["wide", "large"]}
            className = {cs(btnCss.normalize, btnCss.colourRed)}
          >
            Rejected
          </Button>
        )
      case bidStatus.BID_WAITING: 
        return (
          <Button 
            mods= {["wide", "large"]}
            className = {cs(btnCss.normalize, btnCss.colourOrange)}
          >
            Waiting for confirm
          </Button>
        )
      case bidStatus.BID_AWARDING: 
        return (
          <div className={btnCss.awardWarp}> 
            <div className={btnCss.awardTitle}>
              <div className={btnCss.hintIcon}></div>
              Offer awarded
            </div>
            <div className={btnCss.awardAction}>
              <div className={btnCss.awardTime}>
                <div className={btnCss.timeIcon}></div>
                {bidMsg}
              </div>
              <Button 
                className = {cs(btnCss.colourGreen, btnCss.awardBtn, btnCss.normalize)}
                onClick = {()=> accpetBid(bidNextNode)}
              >
                Accept
              </Button>
            </div>
          </div>
        )
      case bidStatus.BID_AWARD_TIMEOUT:
        return (
          <div className={btnCss.awardWarp}> 
            <div className={cs(btnCss.awardTitle, btnCss.awardTitleGrey)}>
              <div className={btnCss.hintIconWhite}></div>
              Award Timed Out
            </div>
            <div className={btnCss.awardAction}>
              <div className={btnCss.awardTime}>
                <div className={btnCss.timeIcon}></div>
                {bidMsg}
              </div>
              <Button 
                className = {cs(btnCss.colourGreen, btnCss.awardBtn, btnCss.normalize)}
                onClick={bid}
              >
                Reoffer
              </Button>
            </div>
          </div>
        )
      case bidStatus.BID_SENT: 
        return (
          <div className={css.loadsActionsDoubleButtonWarp}>
            <Button
              onClick={bid}
              className={css.singleButton}
            >Reoffer</Button>
          </div>
        ) 
      case bidStatus.BID_ACCEPTED: 
        return (
          <Button 
            mods= {["wide", "large"]}
            className = {cs(btnCss.normalize, btnCss.colourGreen)}
          >
            Offer Accepted
          </Button>
        )
      default:
        console.log('bidType :>> ', bidType);
        return <div>{bidType}</div>
    }
  }else {
    if(isBid && isBooking) {
      return (
        <div className={css.loadsActionsDoubleButtonWarp}>
          <Button
            mods={['action']}
            onClick={book}
            className={css.bookBtn}
          >Book Now</Button>
          <Button
            onClick={bid}
          >{bidPrice ? "Reoffer " : "Make an Offer"}</Button>
        </div>
      )
    }
    if(isBid && !isBooking) {
      return (
        <div className={css.loadsActionsDoubleButtonWarp}>
          <Button
            onClick={bid}
            className={css.singleButton}
          >{bidPrice ? "Reoffer " : "Make an Offer"}</Button>
        </div>
      )
    }
    if(!isBid && isBooking) {
      return (
        <div className={css.loadsActionsDoubleButtonWarp}>
          <Button
            mods={['action']}
            onClick={book}
            className={cs(css.singleButton, css.bookBtn)}
          >Book Now</Button>
        </div>
      )
    }
    return (<div></div>)
  }
};

const BrokerInfoRender = ({
  // isPremium, showAuthModal,
  showPhoneClick,
  isPhoneShow,
  checkedBroker,
  company,
  score,
  hideInfo,
  showBids,
  showPhone,
  trackBrokerLink,
  deleted,
  bookingLoad,
  showCSDTP,
  signup,
  accountLevel,
  showUpgradeToStandard,
  showUpgradeToSaveBrokers,
  showUpgradeToHideBrokers,
  hideConfirm,
  isLoggedIn,
  showLogIn,
  collectionTheCompany,
  noCollectionCompany,
  alterHideConfirm,
  hideBroker,
  emptyCompany,
  saveClick,
  hideClick,
  memberSwitch,
  source,
  loadIdentity,
  makeBid,
  makeBook,
  myloadsType,
  accpetBid,
  showRC,
  bookMapUpdate,
  bidMapUpdate,
  showUpgradeModal,
  autoAction,
  commonHandler,
  ...props
}) => {
  let hide = () => {
    track("save and hide broker", { "save or hide": 1 });
    track("save and hide broker", { "hide broker": 1 });
    if (!showCSDTP) {
      showUpgradeToHideBrokers("hide broker");
    } else if (isLoggedIn && showCSDTP && hideClick) {
      alterHideConfirm({ hideConfirm: true, id: props.broker_id, company });
    }
  };
  let save = () => {
    track("save and hide broker", { "save or hide": 1 });
    track("save and hide broker", { "save broker": 1 });
    if (!isLoggedIn) {
      signup();
    }
    if (!showCSDTP) {
      showUpgradeToSaveBrokers("save broker");
    } else if (isLoggedIn && showCSDTP && saveClick) {
      if (checkedBroker) {
        noCollectionCompany({ id: props.broker_id, company });
      } else {
        collectionTheCompany({ id: props.broker_id, company });
      }
      emptyCompany();
    }
  };

  const upgradeAccount = (source) => {
    const eventName =
      window.location.href.indexOf("searchloads") >= 0
        ? source
        : `${source}_inpage`;
    showUpgradeModal({
      source: eventName,
      type: "pop_upgrade_to_essential_standard",
    });
  };

  let promptRef = null;
  
  const promtSetShow = (e, state) => {
    if (!state) {
      promptRef.style.display = "none";
      return;
    }
    let propmtTop = true;
    const browserHeight = document.body.clientHeight;
    if (e.clientY < 300) {
      propmtTop = false;
    }
    if (browserHeight - e.clientY < 300) {
      propmtTop = true;
    }
    promptRef.style.display = "block";
    promptRef.className = propmtTop
      ? css.brokerInfoPromptCard
      : cs(css.brokerInfoPromptCard, css.brokerInfoPromptCardBottom);
  };

  return (
    <section className={cs(css.group, css.brokerSection)}>
      <Header text="Broker" />
      {hideInfo ? (
        <div>
          <div className={cs(css.notLogged)}>
            <button
              className={cs(css.save, !saveClick && css.unclickable)}
              onClick={save}
            >
              <span
                className={cs(
                  css.inSave,
                  checkedBroker && isLoggedIn && css.collection
                )}
              />
            </button>

            <div>This is a member infomation</div>
          </div>
        </div>
      ) : (
        <div>
          <div className={css.borkerInfoCard}>
            <div className={css.borkerInfoCardHeader}>
              <div className={cs(css.brokerInfoContent, css.brokerInfoHigher)}>
                {company}
              </div>
              <a
                href={props.dot && `/brokers/${props.dot}`}
                target="_blank"
                onClick={trackBrokerLink}
                className={cs(css.brokerInfoContent, css.brokerInfoLink)}
              >
                View Loads
              </a>
            </div>
            <div className={css.borkerInfoCardBody}>
              <div className={css.brokerInfoMiddle}>
                <span className={css.brokerInfoLable}>Phone:</span>
                {parseInt(accountLevel) > 0 ? (
                  <span>
                    {
                      isPhoneShow ? <span>{props.phone}</span> : <span onClick={showPhoneClick} className={css.viewPhone}> View</span>
                    }

                  </span>
                ) : (
                  <a onClick={signup}>Log in to view</a>
                )}
              </div>
              <div className={css.brokerInfoSmall}>
                <span className={css.brokerInfoLable}>DOT: </span>
                {props.dot}
              </div>
              <div className={cs(css.brokerInfoSmall, css.brokerInfoSmallRow)}>
                <span className={css.brokerInfoLable}>Days to Pay: </span>
                {score &&
                  (parseInt(accountLevel) >= 2 ? (
                    score.score ? (
                      score.score
                    ) : (
                      "- -"
                    )
                  ) : (
                    <UnlockBtn onClick={() => upgradeAccount("days_to_pay")} />
                  ))}
              </div>
              <div className={cs(css.brokerInfoSmall, css.brokerInfoSmallRow)}>
                <span className={css.brokerInfoLable}>Credit Score: </span>
                {score &&
                  (parseInt(accountLevel) >= 2 ? (
                    score.days ? (
                      score.days
                    ) : (
                      "- -"
                    )
                  ) : (
                    <UnlockBtn onClick={() => upgradeAccount("credit_score")} />
                  ))}
                <div
                  className={css.brokerInfoPrompt}
                  onMouseEnter={(e) => promtSetShow(e, true)}
                  onMouseLeave={(e) => promtSetShow(e, false)}
                >
                  <img src="/assets/ic-cricle-prompt.png" />
                  <div
                    ref={(node) => {
                      promptRef = node;
                    }}
                    className={css.brokerInfoPromptCard}
                  >
                    <header>Credit Score Hint</header>
                    <div className={css.brokerInfoPromptCardSub}>
                      This is a number representing the broker's
                      creditworthiness
                    </div>
                    <main>
                      <div className={css.brokerInfoPromptRow}>
                        <div className={css.brokerInfoPromptRowLeft}>
                          Lowest risk:
                        </div>
                        <div className={css.brokerInfoPromptRowRight}>101+</div>
                      </div>
                      <div className={css.brokerInfoPromptRow}>
                        <div className={css.brokerInfoPromptRowLeft}>
                          Low risk:
                        </div>
                        <div className={css.brokerInfoPromptRowRight}>
                          85-100
                        </div>
                      </div>
                      <div className={css.brokerInfoPromptRow}>
                        <div className={css.brokerInfoPromptRowLeft}>
                          Medium risk:
                        </div>
                        <div className={css.brokerInfoPromptRowRight}>
                          55-84
                        </div>
                      </div>
                      <div className={css.brokerInfoPromptRow}>
                        <div className={css.brokerInfoPromptRowLeft}>
                          High risk:
                        </div>
                        <div className={css.brokerInfoPromptRowRight}>1-54</div>
                      </div>
                      <div className={css.brokerInfoPromptRow}>
                        <div className={css.brokerInfoPromptRowLeft}>
                          New to rate:
                        </div>
                        <div className={css.brokerInfoPromptRowRight}>0</div>
                      </div>
                    </main>
                  </div>
                </div>
              </div>
              <div className={cs(css.brokerInfoSmall, css.brokerInfoBtnGroup)}>
                {parseInt(accountLevel) >= 0 ? (
                  <button
                    className={cs(css.save, !saveClick && css.unclickable)}
                    onClick={save}
                  >
                    <span
                      className={cs(
                        css.inSave,
                        checkedBroker && isLoggedIn && css.collection
                      )}
                    />
                  </button>
                ) : null}
                {parseInt(accountLevel) > 0 ? (
                  <button
                    className={cs(css.save, !hideClick && css.unclickable)}
                    onClick={hide}
                  >
                    <span className={cs(css.inhide)} />
                  </button>
                ) : null}
              </div>
            </div>
          </div>
          <LoadActions
            updateBook={bookMapUpdate}
            updateBid={bidMapUpdate}
            status={{
              ...getLoadStatus(props.id),
              myloadsType,
              isBid: props.biddable,
              isBooking: props.book_now,
            }}
            bid={() =>
              !(parseInt(accountLevel) > 0)
                ? showLogIn()
                : makeBid()
            }
            book={() =>
              !(parseInt(accountLevel) > 0)
                ? showLogIn()
                : makeBook()
            }
            accpetBid={accpetBid}
            showRC={showRC}
          />
        </div>
      )}
    </section>
  );
};

class BrokerInfo extends Component {
  constructor(props){
    super(props);
    this.state = {
      isPhoneShow: false
    }
  }

  componentDidMount() {
    this.autoAction();

  }
  autoAction = () => {
    const { autoAction } = this.props;
    if(!autoAction) return 
    const isBid =  this.props.biddable;
    const isBooking = this.props.book_now;

    const status = autoAction()
    if(isBid && status === "bid") {
      this.makeBid()
    }
    if(isBooking && status === "book") {
      this.makeBook()
    }
  }

  showPhoneClick = () => {
    const { searchId } = this.props;
    track("Load Actions", {
      Action: "View Phone",
      placement: getLocation(),
      searchId,
    })
    this.setState({
      isPhoneShow: true
    })
  }

  popupDispatcher = ({code, id, shipment, nextNode, verifyUrl, actionType}) => {
    const {
      showBid,
      showBook,
      showLSBidPending,
      showLSBookPending,
      showPending,
      showNotinNetwork,
      showLoadsmartOnboard,
      shouBidParade,
      showNotinNetworkBid,
    } = this.props;
    switch(code){
      case loadStatus.BID_PRICE: 
        return showBid({
          shipmentId: id, 
          curRate: shipment.target_price, 
          brokerName: shipment.contact,
          nextNode
        })
      case loadStatus.BOOK_CONFIRM: 
        return showBook({
          shipmentId: id, 
          price: shipment.target_price,
          nextNode
        })
      case loadStatus.LOADSMART_PENDING:{
        if(actionType === "bid") {
          return showLSBidPending();
        }else if(actionType === "book") {
          return showLSBookPending();
        }
      }
        
      case loadStatus.L2_PENDING:
        return showPending() 
      case loadStatus.NOT_IN_NETWORK:
        return showNotinNetwork()
      case loadStatus.NOT_IN_NETWORK_BID: 
        return showNotinNetworkBid();
      case loadStatus.LOADSMART_AUTO_UPLOAD:
        return showLoadsmartOnboard({
          verifyUrl
        })
      case loadStatus.LOADSMART_MANUAL_UPLOAD:
        return showLoadsmartOnboard({
          verifyUrl
        })
      case loadStatus.BID_PROFILE_VAILD:
        return shouBidParade();
      default: 
        console.log('code :>> ', code);
    }
  }

  commonHandler = (handler, id, shipment, actionType) => {
    handler(id).then(({code, nextNode, verifyUrl})=>this.popupDispatcher({code, id, shipment, nextNode, verifyUrl, actionType})).catch(err=> console.error(err))
  }

  makeBid = () => {
    const { makeBidDynamic, searchId } = this.props;
    track("Load Actions", {
      Action: "Bid",
      loadId: this.props.id,
      searchId,
      Placement: getLocation(),
    })
    return this.commonHandler(makeBidDynamic, this.props.id, this.props, "bid")
  }

  makeBook = () => {
    const { createBookDynamic, searchId} = this.props;
    track("Load Actions", {
      Action: "Book",
      loadId: this.props.id,
      searchId,
      Placement: getLocation(),
    })
    return  this.commonHandler(createBookDynamic, this.props.id, this.props, "book")
  }

  render() {
    return BrokerInfoRender({...this.props, ...this.state, showPhoneClick: this.showPhoneClick, commonHandler: this.commonHandler, makeBid: this.makeBid, makeBook: this.makeBook})
  }
}

const noReply = {
  "donotsendemail@posteverywhere.com": true,
  "do-not-reply@posteverywhere.com": true,
  "dispatch+trektrans@truckerpath.com": true,
  "donotsendemails@posteverywhere.com": true,
};

const usableEmail = (email) => {
  if (!email) {
    return false;
  }

  const value = email.toLowerCase();
  if (noReply[value] === true) {
    return false;
  }

  if (value.endsWith("@posteverywhere.com")) {
    return false;
  }

  if (value.endsWith("@truckerpath.com")) {
    return false;
  }

  return true;
};

export default connect(
  (
    state,
    {
      accountLevel,
      isPremium,
      email,
      saveClick,
      hideClick,
      source,
      loadsSearch,
    }
  ) => {
    const isEmailUsable = usableEmail(email);
    const showCSDTPfunc = (accountLevel) => {
      return true;
      // if (Number(accountLevel) >= state.account.standard) {
      //   return true;
      // }
      // return false;
    };

    const showBids =
      config.offers === "offers" || config.offers === "offers&phone";
    const showPhone =
      config.offers === "phone" || config.offers === "offers&phone";
    return {
      hideInfo: isPremium && !state.user.isLoggedIn,
      showBids: showBids && isEmailUsable,
      showPhone: showPhone || !isEmailUsable,
      showCSDTP: showCSDTPfunc(accountLevel),
      hideConfirm: state.hideConfirm.hideConfirm,
      isLoggedIn: state.user.isLoggedIn,
      saveClick: saveClick,
      hideClick: hideClick,
      memberSwitch: state.premiumSwitch.memberSwitchData,
      source,
      bookMapUpdate: state.bookings.updatedTime,
      bidMapUpdate: state.bids.updatedTime,
      searchId: get(loadsSearch, "results.searchId")
    };
  },
  mapDispatch({
    showAuthModal: () => modalChange("signup", "premium_loads"),
    trackBrokerLink: (props) => {
      track("open_broker_link", {
        DOT: props.dot,
        loadId: props.id,
      });
      track("Load Actions", {
        Action: "View Broker Loads",
        loadId: props.id,
        searchId: getSearchId(),
        Placement: getLocation(),
      })
    },
    signup: () => modalChange(modes.SIGNUP, "load-card-details"),
    showUpgradeToStandard: (props, source) =>
      modalChange("pop", {
        source: source,
        type: "pop_upgrade_to_standard",
      }),
    showUpgradeToSaveBrokers: (props, source) =>
      modalChange("pop", {
        source: source,
        type: "pop_upgrade_to_save_brokers",
      }),
    showUpgradeToHideBrokers: (props, source) =>
      modalChange("pop", {
        source: source,
        type: "pop_upgrade_to_hide_brokers",
      }),
    alterHideConfirm: (props, data) => alterHideConfirm(data),
    emptyCompany: () => emptyCompany(),
    showLogIn: () => modalChange("login", "anonymous_banner"),
    hideBroker: (props, data) => props.hideBroker(data),
    collectionTheCompany: (props, data) => props.collectionTheCompany(data),
    noCollectionCompany: (props, data) => props.noCollectionCompany(data),
    showBid: (props, {shipmentId, curRate, brokerName, nextNode}) => modalChange(modes.CREATE_BID, {type: 'askPop', shipmentId, curRate, brokerName, nextNode}),
    showBook: (props, {shipmentId , price, nextNode}) => modalChange(modes.BOOKNOW, {type: 'askPop', shipmentId ,price, nextNode}),
    showLSBidPending: (props, data) => modalChange(modes.PENDING, {type: 'askPop', pendingType: 'bid'}),
    showLSBookPending: (props, data) => modalChange(modes.PENDING, {type: 'askPop', pendingType: 'book'}),
    showPending: (props, data) => modalChange(modes.PENDING, {type: 'askPop', pendingType: 'l2'}),
    showNotinNetwork: (props, data) => modalChange(modes.NOT_IN_NETWORK, {type: 'askPop'}),    
    showNotinNetworkBid: (props, data) => modalChange(modes.NOT_IN_NETWORK_BID, {type: 'askPop'}),    
    showLoadsmartOnboard: (props, { verifyUrl}) => modalChange(modes.LOADSMART_ONBOARD, {type: 'askPop', verifyUrl}),    
    shouBidParade: (props, data) => modalChange(modes.BID_PARADE, {type: 'askPop'}), 
    makeBidDynamic: (props, shipmentId) => makeBidDynamic({shipmentId}),
    createBookDynamic: (props, shipmentId) => createBookDynamic(shipmentId),
    accpetBid: (props, nextNode) => accpetBid(nextNode),
    showRC: (props, urls)  => modalChange(modes.BOOKRC_VIEW, {type: 'askPop', urls}),
    showUpgradeModal :(_,{source,type}) => modalChange('pop', {
      source: source,
      type: type,
    }),
  })
)(BrokerInfo)



// WEBPACK FOOTER //
// ./src/components/search/results/LoadCard/BrokerInfo.js